<template>
  <div>
    <div
      v-for="represent in represents"
      :key="-represent.id"
      class="report-tree-node"
      :class="{ 'node-pt4': representsSelectType !== 'multiple' }"
    >
      <v-checkbox
        v-if="representsSelectType === 'multiple'"
        v-model="represent.is_selected"
        :disabled="represent.status === 'empty'"
        hide-details
        @change="$emit('repr-select', represent)"
      >
        <template v-slot:append>
          <div
            v-if="represent.status !== 'empty'"
            class="represent-label represent-selectable"
            @click="reprExpand(represent)"
          >
            {{ represent.name }}
            <v-icon>
              {{
                represent.status === 'expanded'
                  ? 'fas fa-caret-down'
                  : represent.status === 'loading'
                    ? 'mdi-reload'
                    : 'fas fa-caret-right'
              }}
            </v-icon>
          </div>
          <div
            v-else
            class="represent-label"
          >
            {{ represent.name }}
          </div>
        </template>
      </v-checkbox>
      <template v-if="representsSelectType === 'none'">
        <div
          v-if="represent.status !== 'empty'"
          class="represent-label represent-selectable"
          @click="reprExpand(represent)"
        >
          {{ represent.name }}
          <v-icon>
            {{
              represent.status === 'expanded'
                ? 'fas fa-caret-down'
                : represent.status === 'loading'
                  ? 'mdi-reload'
                  : 'fas fa-caret-right'
            }}
          </v-icon>
        </div>
        <div
          v-else
          class="represent-label"
        >
          {{ represent.name }}
        </div>
      </template>
      <report-tree-node
        v-if="represent.status === 'expanded' || represent.status === 'loading'"
        :is-root="false"
        :initial-represents="represent.children"
        :initial-all-points="allPoints"
        :represent-points="represent.points"
        :represents-select-type="representsSelectType"
        :points-select-type="pointsSelectType"
        :limit-selected-points="limitSelectedPoints"
        @repr-select="$emit('repr-select', $event)"
        @point-select="$emit('point-select', $event)"
        @selected-repr-expand="$emit('selected-repr-expand', $event)"
      />
    </div>
    <template v-if="pointsSelectType === 'multiple'">
      <div
        v-for="point in representPoints"
        :key="point.id"
        class="report-tree-node point-node"
      >
        <v-checkbox
          v-model="point.is_selected"
          :disabled="limitSelectedPoints && !point.is_selected"
          :label="point.name"
          hide-details
          @change="$emit('point-select', point)"
        />
      </div>
    </template>
    <template v-if="pointsSelectType === 'single'">
      <div
        v-for="point in representPoints"
        :key="point.id"
        class="report-tree-node point-node"
        @click="$emit('point-select', point)"
      >
        {{ point.name }}
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ReportTreeNode',
  props: [
    'isRoot',
    'initialRepresents',
    'initialAllPoints',
    'representPoints',
    'representsSelectType',
    'pointsSelectType',
    'limitSelectedPoints'
  ],
  data () {
    return {
      represents: [],
      allPoints: []
    }
  },
  mounted () {
    if (this.isRoot) {
      this.getRepresentsApi()
    } else {
      this.represents.push(...this.initialRepresents)
      this.allPoints = this.initialAllPoints
    }
  },
  methods: {
    getRepresentsApi () {
      axios.get(`/api/represents/all/`)
        .then((response) => {
          const represents = []
          response.data.results.map(represent => {
            represents.push({
              'id': represent.represent_id,
              'parent_id': represent.parent_id,
              'name': represent.name,
              'status': 'initial',
              'is_selected': false,
              'children': [],
              'points': []
            })
          })
          this.representsTreeFilling(null, represents)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    representsTreeFilling (parent, represents) {
      const children = represents.filter(represent =>
        represent.parent_id === (parent ? parent.id : null)
      )
      children.map(child => {
        this.representsTreeFilling(child, represents)
      })
      if (parent) {
        parent.children.push(...children)
      } else {
        this.represents.push(...children)
      }
    },
    getRepresentPointsApi (represent) {
      axios.get(`/api/represents/${represent.id}/points/`)
        .then(response => {
          response.data.map(point => {
            if (!this.allPoints[point.point_id]) {
              this.allPoints[point.point_id] = {
                'id': point.point_id,
                'name': point.name,
                'is_selected': false
              }
            }
            represent.points.push(this.allPoints[point.point_id])
          })
          if (represent.is_selected) {
            represent.points.map(point => {
              point.is_selected = true
              this.$emit('point-select', point)
            })
          }
          if (represent.children.length || represent.points.length) {
            represent.status = 'expanded'
          } else {
            represent.is_selected = false
            represent.status = 'empty'
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    reprExpand (represent) {
      if (represent.status === 'initial') {
        represent.status = 'loading'
        this.getRepresentPointsApi(represent)
        if (represent.is_selected) {
          this.$emit('selected-repr-expand', represent)
        }
      } else if (represent.status === 'minimized') {
        represent.status = 'expanded'
      } else if (represent.status === 'expanded') {
        represent.status = 'minimized'
      }
    }
  }
}
</script>

<style scoped>
  .report-tree-node {
    padding-left: 20px;
    position: relative;
    white-space: nowrap;
  }
  .node-pt4 {
    padding-top: 4px;
  }
  .report-tree-node >>> .v-input__append-outer {
    margin: 0;
  }
  .represent-label {
    height: 24px;
    padding: 2px 0 2px 2px;
    line-height: 20px;
    font-size: 14px;
    color: rgba(0,0,0,.87);
  }
  .represent-selectable {
    cursor: pointer;
  }
  .represent-selectable > .v-icon {
    font-size: 20px;
  }
  .report-tree-node.point-node {
    line-height: 22px;
    color: #1976d2;
    cursor: pointer;
  }
  .represent-label + div > .report-tree-node.point-node {
    padding-top: 6px;
  }
  .report-tree-node.point-node >>> .v-label {
    color: #1976d2;
  }
  .report-tree-node .report-tree-node:before {
    content: "";
    position: absolute;
    top:-10px;
    left:10px;
    width:10px;
    height:28px;
    border-left: 1px solid black;
    border-bottom: 1px solid black;
  }
  .report-tree-node .report-tree-node:first-child:before {
    top: 3px;
    height: 15px;
  }
  .report-tree-node .report-tree-node:not(:last-child):after {
    content: "";
    position: absolute;
    top: 15px;
    bottom: 10px;
    left: 10px;
    border-left: 1px solid black;
  }
  .v-input--hide-details {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/spa/reports/ReportTreeNode.vue